"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TextArea = antd_1.Input.TextArea;
var DlgMessageEditor = /** @class */ (function (_super) {
    __extends(DlgMessageEditor, _super);
    function DlgMessageEditor(props) {
        return _super.call(this, props) || this;
    }
    DlgMessageEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
                messageTitle: data.messageTitle,
                messageBody: data.messageBody,
            });
        });
        this.setState({
            visible: false,
            dialogTitle: "",
            messageTitle: "",
            messageBody: "",
        });
        this.doReSetRules();
    };
    DlgMessageEditor.prototype.doReSetRules = function () {
        this.setState({
        // amount_rules: {isError: false },
        });
    };
    DlgMessageEditor.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgMessageEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        return true;
    };
    DlgMessageEditor.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.messageTitle, this.state.messageBody);
            }
        }
    };
    DlgMessageEditor.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgMessageEditor.prototype.onMessageTitleChange = function (e) {
        this.props.controller.SetMessageTitle(e.target.value);
    };
    //private onPromoCodeChange(e: React.ChangeEvent<HTMLInputElement>) {
    //    this.props.controller.SetPromoCode(e.target.value)
    //}
    DlgMessageEditor.prototype.onMessageBodyChange = function (e) {
        this.props.controller.SetMessageBody(e.target.value);
    };
    //private onIsUsePromoCodeChange(checked: boolean) {
    //    this.props.controller.SetIsHasPromoCode(checked)
    //}
    //private onIsImportantChange(checked: boolean) {
    //    this.props.controller.SetIsImportant(checked)
    //}
    DlgMessageEditor.prototype.render = function () {
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: true, maskClosable: false, okType: "primary", style: { minWidth: 300 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement("div", { style: { width: "100%", textAlign: "left", fontWeight: "bold", margin: 5, marginLeft: 0 } }, "\u0422\u0435\u043C\u0430 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F"),
                React.createElement(antd_1.Input, { onChange: this.onMessageTitleChange.bind(this), value: this.state.messageTitle }),
                React.createElement("div", { style: { width: "100%", textAlign: "left", fontWeight: "bold", margin: 5, marginLeft: 0 } }, "\u0422\u0435\u043A\u0441\u0442 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F"),
                React.createElement(TextArea, { rows: 4, onChange: this.onMessageBodyChange.bind(this), value: this.state.messageBody })));
    };
    return DlgMessageEditor;
}(React.Component));
exports.default = DlgMessageEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgMessageEditor.tsx
// module id = 2331
// module chunks = 0